import { DateTime } from 'luxon';
import { useCallback, useEffect, useState } from 'react';
import { LocalStorage } from 'utils/LocalStorage';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';

const HIDE_MODAL_TIME_SEC = 365 * 24 * 60 * 60; // 30 days

export const useShowIntroModal = (
  modalKey: LocalStorageKey,
  options: { extraCondition?: () => Promise<boolean> | boolean; hideTimeSec?: number } = {},
) => {
  const hideTimeSec = options.hideTimeSec ?? HIDE_MODAL_TIME_SEC;
  const [show, setShow] = useState(false);

  const markHideTime = useCallback(() => {
    LocalStorage.setItem(modalKey, DateTime.now().toJSDate().getTime().toString());
    setShow(false);
  }, [modalKey]);

  useEffect(() => {
    (async () => {
      const condition = (await options.extraCondition?.()) ?? true;
      if (!condition) {
        return;
      }

      const hideTime = LocalStorage.getItem(modalKey);
      if (!hideTime) {
        setShow(true);
        return;
      }

      if (DateTime.now().minus({ second: hideTimeSec }) > DateTime.fromMillis(Number(hideTime as string))) {
        setShow(true);
      }
    })();
  }, [hideTimeSec, modalKey, options]);

  return { show, onHide: markHideTime };
};
